export default {
    bg: require('../assets/images/shower.bathroom.png'),
    sprites: [{
        image: require('../assets/images/shower.elephant.png'),
        x: 60,
        y: 50,
        rot: 10,
        scale: .8,
    }, {
        image: require('../assets/images/shower.deer.png'),
        x: 20,
        y: 23,
        rot: -15,
        scale: .65,
    }],
}